import { useId } from 'react';
import { validateHexColor } from '../../lib/validators';

interface ColorPickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export function ColorPicker({ label, value, onChange, required }: ColorPickerProps) {
  const id = useId();
  const isValid = validateHexColor(value);

  return (
    <div className="mb-4">
      <label htmlFor={id} className="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="flex items-center gap-3">
        <input
          id={id}
          type="color"
          value={isValid ? value : '#000000'}
          onChange={(e) => onChange(e.target.value)}
          className="w-10 h-10 p-0 border-0 rounded cursor-pointer"
        />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`flex-1 px-3 py-2 rounded border bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-50 border-slate-300 dark:border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500 ${!isValid ? 'border-red-500' : ''}`}
          placeholder="#3b82f6"
        />
      </div>
      {!isValid && <p className="mt-1 text-xs text-red-500">請輸入有效的 HEX 顏色代碼</p>}
    </div>
  );
}
